import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'encodeColor'
})
export class EncodeColorPipe implements PipeTransform {

	transform(hash_hexcode: string): string {
		return !!hash_hexcode ? encodeURIComponent(hash_hexcode) : "";
	}

}
